import { useQueries } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from './api';

export const useTreatmentCounts = (args?: TTreatmentCountsArgs) => {
  const {
    primaryPracticeId: currentPractice,
    primaryOrganizationId: currentOrg,
  } = useSelector(
    (state: {
      login: {
        user: {
          primaryPracticeId?: string;
          primaryOrganizationId?: string;
        };
      };
    }) => state.login.user,
  );

  const key = `${currentPractice}/appointments/treatmentsCounts`;

  return useQueries({
    queries: args?.length
      ? args.map((unifiedIds) => {
          const unifiedAppointmentIds = unifiedIds?.map<
            string | null | undefined
          >((ev) => ev.unifiedAppointmentId);
          return {
            queryKey: [key, unifiedAppointmentIds],
            queryFn: () => {
              return makeAPIRequestReactQuery<TBulkTreatmentCounts>(
                key,
                { unifiedAppointmentIds: unifiedAppointmentIds },
                'get',
                {
                  headers: {
                    practice: currentPractice,
                    org: currentOrg,
                  },
                },
              );
            },
            enabled: !!unifiedAppointmentIds?.filter(Boolean).length,
          };
        })
      : [],
  });
};

type TTreatmentCountsArgs = (
  | {
      unifiedAppointmentId?: string | null;
    }[]
  | undefined
)[];

export type TTreatmentCounts = {
  unifiedAppointmentId?: string;
  outstanding?: number;
  scheduled?: number;
};

export type TBulkTreatmentCounts =
  | {
      counts: TTreatmentCounts[] | undefined;
    }
  | undefined;
